import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MapPin, ArrowLeft, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { ATTR } from "../pages/CollectionPage";
import Reveal from "./Reveal";
import { Skel } from "./Skeleton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VarietiesSection() {
  const { lang, t } = useApp();
  const [items, setItems] = useState(null);
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  useEffect(() => {
    axios.get(`${API}/content/varieties`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <section id="varieties" className="lux-section varieties-section" data-testid="varieties-section">
      <Reveal>
        <div className="section-head">
          <span className="section-tag">{t("varieties.tag")}</span>
          <h2 className="section-title">{t("varieties.title")}</h2>
          <p className="section-sub">{t("varieties.sub")}</p>
        </div>
      </Reveal>
      <div className="variety-grid variety-grid-8">
        {items === null && Array.from({ length: 8 }).map((_, i) => <Skel key={i} h={360} r={18} />)}
        {(items || []).slice(0, 8).map((v, i) => (
          <Reveal key={v.slug} delay={(i % 4) * 110}>
            <Link to={`/varieties/${v.slug}`} className="variety-card-link" data-testid={`variety-link-${v.slug}`}>
              <article className="variety-card glass-card" data-testid={`variety-card-${v.slug}`}>
                <div className="variety-img-wrap">
                  <img src={v.hero_image} alt={v[`title_${lang}`]} className="variety-img" loading="lazy" />
                  {v.attrs?.region && (
                    <span className="variety-region">
                      <MapPin size={13} />
                      {ATTR.region[v.attrs.region]?.[lang]}
                    </span>
                  )}
                </div>
                <div className="variety-body">
                  <h3 className="variety-name">
                    {v.title_ar} <span className="variety-name-en">{v.title_en}</span>
                  </h3>
                  <p className="variety-desc">{v[`summary_${lang}`]}</p>
                  <div className="trait-row">
                    {v.attrs && ["sweetness", "texture"].map((k) => ATTR[k][v.attrs[k]] && (
                      <span key={k} className="trait-chip">{ATTR[k][v.attrs[k]][lang]}</span>
                    ))}
                  </div>
                  <span className="content-card-cta">
                    {t("content.readMore")} <Arrow size={14} />
                  </span>
                </div>
              </article>
            </Link>
          </Reveal>
        ))}
      </div>
      <div className="section-more">
        <Link to="/varieties" className="btn-lux-ghost" data-testid="varieties-all-link">{t("varieties.all")}</Link>
      </div>
    </section>
  );
}
